import * as React from "react";
import styles from "./Card.scss";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    onMouseDown?: React.MouseEventHandler<HTMLElement>;
    onTouchStart?: React.TouchEventHandler<HTMLElement>;
}

class Card extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={`${styles.card} ${this.props.className}`} style={this.props.style} onMouseDown={this.props.onMouseDown} onTouchStart={this.props.onTouchStart}>
                {this.props.children}
            </div>
        );
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/Components/Common/Card/Card.tsx